export default {
  relatedTitle: 'Related Illustrations, Icons and Drawings',
};
